import styled from 'styled-components';
import { prem } from 'styles/helpers/spacing';

const NoInvitationWrapper = styled.div`
  text-align: center;
  margin-top: ${prem(60)};
`;

export { NoInvitationWrapper };
